module.exports = __webpack_public_path__ + "img/pre6-celular.4ad802cd.jpg";